import React from 'react';
import {
  Box,
  Container,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Typography,
  Button
} from '@mui/material';
import { Event } from '@mui/icons-material';
import SectionTitle from '../common/SectionTitle';

const EventsSection = ({ events, onParticipate }) => {
  return (
    <Box id="events-section" data-section="events" sx={{ mt: 6, pb: 4 }}>
      <Container maxWidth="lg">
        <Box sx={{ bgcolor: 'rgba(0, 0, 0, 0.7)', borderRadius: 3, p: { xs: 2, md: 3 }, pb: { xs: 4, md: 5 } }}>
          <SectionTitle
            title="Próximos Eventos"
            subtitle="Fique por dentro do que vem por aí"
            align="center"
            color="#FF6B35"
          />

          <Grid container spacing={3} justifyContent="center">
            {events.slice(0, 3).map((event) => (
              <Grid item xs={12} md={4} key={event.id}>
                <Card
                  sx={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    border: '1px solid rgba(255, 107, 53, 0.2)',
                    '&:hover': {
                      transform: 'translateY(-4px)',
                      border: '1px solid rgba(255, 107, 53, 0.5)',
                      boxShadow: '0 8px 30px rgba(255, 107, 53, 0.2)',
                    },
                    transition: 'all 0.3s ease',
                  }}
                >
                  {event.banner_image && (
                    <CardMedia
                      component="img"
                      height="200"
                      image={event.banner_image}
                      alt={event.title}
                      loading="lazy"
                      decoding="async"
                      onError={(e) => {
                        e.currentTarget.onerror = null;
                        e.currentTarget.src = '/img/bg.png';
                      }}
                    />
                  )}
                  <CardContent sx={{ flexGrow: 1 }}>
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 600,
                        mb: 1,
                        color: '#FF6B35',
                        textShadow: '0 0 3px rgba(255, 107, 53, 0.2)'
                      }}
                    >
                      {event.title}
                    </Typography>
                    <Typography variant="body2" sx={{ opacity: 0.7, mb: 2 }}>
                      {event.description}
                    </Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                      <Event sx={{ fontSize: 16, color: '#00D4FF' }} />
                      <Typography variant="body2">
                        {new Date(event.event_date).toLocaleDateString('pt-BR')}
                      </Typography>
                    </Box>
                    <Button
                      variant="outlined"
                      size="small"
                      fullWidth
                      onClick={() => onParticipate(event)}
                      sx={{
                        borderColor: '#FF6B35',
                        color: '#FF6B35',
                        '&:hover': {
                          borderColor: '#FF8C5A',
                          bgcolor: 'rgba(255, 107, 53, 0.1)',
                          boxShadow: '0 0 15px rgba(255, 107, 53, 0.3)',
                        },
                      }}
                    >
                      Participar
                    </Button>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>

          {events.length === 0 && (
            <Card sx={{ border: '1px solid rgba(255, 107, 53, 0.2)' }}>
              <CardContent sx={{ textAlign: 'center', py: 6 }}>
                <Event sx={{ fontSize: 60, color: 'rgba(255, 255, 255, 0.3)', mb: 2 }} />
                <Typography variant="h6" sx={{ opacity: 0.7 }}>
                  Nenhum evento programado
                </Typography>
              </CardContent>
            </Card>
          )}
        </Box>
      </Container>
    </Box>
  );
};

export default EventsSection;
